import React, { useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { selectIsAdmin } from 'modules/current-user/selectors';
import { getInvestorCompaniesInvestments } from 'modules/investors/action';
import { selectInvestorCompaniesInvestments } from 'modules/investors/selectors';
import { useAppDispatch, useAppSelector } from 'modules/store';

import InvestorCompaniesInvestments from './InvestorCompaniesInvestments';
import InvestorNumberOfShares from './InvestorNumberOfShares';

const InvestorInvestments = () => {
  const dispatch = useAppDispatch();
  const { isLoading, list } = useAppSelector(selectInvestorCompaniesInvestments);
  const hasInvestments = !!list?.flatMap(({ investments }) => investments)?.length;
  const isAdmin = useAppSelector(selectIsAdmin);
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      dispatch(getInvestorCompaniesInvestments({ isAdmin, id, page: 1, per_page: 1000 }));
    }
  }, [dispatch, id]);

  return (
    <div className='flex flex-col gap-10'>
      <InvestorCompaniesInvestments isLoading={isLoading} list={list} hasInvestments={hasInvestments} />
      <InvestorNumberOfShares isLoading={isLoading} list={list} hasInvestments={hasInvestments} />
    </div>
  );
};

export default InvestorInvestments;
